import { render, staticRenderFns } from "./BankSetup.vue?vue&type=template&id=40706b93&"
import script from "./BankSetup.vue?vue&type=script&lang=js&"
export * from "./BankSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports